import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { EASE } from "./motion";

const lines = ["The operating system", "built around restaurants."];

export default function OpeningStatement() {
  const navigate = useNavigate();
  return (
    <section
      data-testid="opening-statement"
      className="relative min-h-[100svh] flex flex-col justify-center px-6 md:px-12 pt-28 pb-24"
    >
      <div className="mx-auto max-w-[1400px] w-full">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.2 }}
          className="text-xs md:text-sm tracking-[0.25em] uppercase text-brass mb-10 md:mb-16"
        >
          For restaurants, gastropubs and hospitality groups
        </motion.p>

        <h1
          style={{ lineHeight: 1.16 }}
          className="font-display font-light text-verlo text-[2.7rem] sm:text-6xl md:text-7xl lg:text-[7.5rem] tracking-tight max-w-6xl"
        >
          {lines.map((line, i) => (
            <span key={i} className="reveal-mask">
              <motion.span
                className="block pb-[0.06em]"
                initial={{ y: "110%" }}
                animate={{ y: 0 }}
                transition={{ duration: 1, ease: EASE, delay: 0.4 + i * 0.16 }}
              >
                {line}
              </motion.span>
            </span>
          ))}
        </h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: EASE, delay: 1 }}
          className="mt-10 md:mt-14 text-xl md:text-2xl leading-loose text-verlo max-w-2xl"
        >
          Run a better restaurant. Every shift, every site. The floor, the books and
          the numbers, finally working together.
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 1.3 }}
          className="mt-12 flex items-center gap-7"
        >
          <button
            data-testid="hero-try-verlo"
            onClick={() => navigate("/sandbox")}
            className="inline-flex items-center bg-brass text-paper font-medium px-7 py-3.5 rounded-full hover:bg-verlo transition-colors duration-300"
          >
            Try Verlo
          </button>
          <a
            data-testid="hero-book-demo"
            href="mailto:hello@verlohq.com"
            className="text-sm text-verlo/60 hover:text-verlo underline underline-offset-4 decoration-verlo/20 hover:decoration-verlo transition-all"
          >
            Book a demo
          </a>
        </motion.div>
      </div>

      <div className="absolute bottom-10 left-6 md:left-12 flex flex-col items-start gap-3">
        <motion.div
          initial={{ scaleY: 0 }}
          animate={{ scaleY: 1 }}
          transition={{ duration: 1.2, ease: EASE, delay: 1.6 }}
          style={{ transformOrigin: "top" }}
          className="w-px h-16 bg-verlo/40"
        />
      </div>
    </section>
  );
}
